import React, { useState } from 'react';
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import Button from '../../../Shared/components/controls/Button';
import './style.scss';
import clsx from 'clsx';

import 'swiper/swiper.scss';
import 'swiper/modules/navigation/navigation.scss';
import { Swiper } from 'swiper/react/swiper-react.js';
import { SwiperSlide } from 'swiper/react/swiper-react.js';
import { Navigation } from 'swiper';
import { withTranslation } from 'react-i18next';

const HeaderBannerLandingMobile = (props) => {
  const { i18n, params, isEliteTheme } = props;
  const { items: allBanners } = props?.fields;

  const [activeItem, setActiveItem] = useState(0);
  if (!!allBanners && allBanners.length <= 0) return null;
  //constants
  const prevControlId = 'headerBannerLanding_prevID';
  const nextControlId = 'headerBannerLanding_nextID';
  const lang = i18n.language;
  //states
  //variables
  let shouldRenderPrev = activeItem !== 0;
  let shouldRenderNext = activeItem !== allBanners.length - 1;
  const shouldRenderNavigation = allBanners.length > 1;

  //return data
  return (
    <div
      className={clsx(
        'headerBannerLanding',
        isEliteTheme ? 'theme-elite' : 'theme-default',
        !shouldRenderNavigation ? 'noNavigation' : '',
        'add-margins',
        params?.Styles
      )}
    >
      <div className="wrap-swiper">
        <Swiper
          modules={[Navigation]}
          slidesPerView={1}
          dir={lang === 'en' ? 'ltr' : 'rtl'}
          autoHeight={true}
          onSlideChange={(swiper) => {
            if (swiper.activeIndex !== activeItem) setActiveItem(swiper.activeIndex);
          }}
          navigation={{
            prevEl:
              prevControlId && typeof document !== 'undefined'
                ? document.getElementById(prevControlId)
                : undefined,
            nextEl:
              nextControlId && typeof document !== 'undefined'
                ? document.getElementById(nextControlId)
                : undefined,
          }}
        >
          {allBanners.map((item, index) => {
            return (
              <SwiperSlide key={index} className="item flex-it flex-align-item-center">
                <BannerItem banner={item.fields} />
              </SwiperSlide>
            );
          })}
        </Swiper>

        <div
          className="navigation flex-it flex-align-item-center flex-justify-between"
          id="headerBannerLanding-navigation-id"
        >
          <div
            id={prevControlId}
            className={clsx(
              'nav-prev',
              'navigation-button',
              'flex-it',
              'flex-align-item-center',
              !shouldRenderPrev ? 'disabled' : ''
            )}
          >
            <img src={`/-/jssmedia/Project/FAB2/shared/images/swiper-left-arrow.svg`} />
          </div>

          {shouldRenderNavigation && (
            <div className="numbers flex-it flex-align-item-center">
              <div className="number big flex-it flex-align-item-center">0{activeItem + 1}</div>
              <div className="number seperator flex-it flex-align-item-center">/</div>
              <div className="number flex-it flex-align-item-center">0{allBanners.length}</div>
            </div>
          )}
          <div
            id={nextControlId}
            className={clsx(
              'nav-next',
              'navigation-button',
              'flex-it',
              'flex-align-item-center',
              !shouldRenderNext ? 'disabled' : ''
            )}
          >
            <img src={`/-/jssmedia/Project/FAB2/shared/images/swiper-right-arrow.svg`} />
          </div>
        </div>
      </div>
    </div>
  );
};

const BannerItem = ({ banner }) => {
  //constants
  const primaryButton = banner.primaryButton;
  const secondaryButton = banner.secondaryButton;
  const tertiaryButton = banner.tertiaryButton;
  //rendering
  const shouldRenderImage = !!banner?.image;
  const shouldRenderTitle = !!banner?.heading?.value;
  const shouldRenderText = !!banner?.text?.value;

  const shouldRenderPrimaryButton = !!primaryButton && primaryButton?.value?.href !== '';
  const shouldRenderSecondaryButton = !!secondaryButton && secondaryButton?.value?.href !== '';
  const shouldRenderTertiaryButton = !!tertiaryButton && tertiaryButton?.value?.href !== '';
  const shouldRenderAllButtons =
    shouldRenderPrimaryButton || shouldRenderSecondaryButton || shouldRenderTertiaryButton;
  return (
    <div className="item-wrap">
      <div className="text-picture-wrap">
        <div className="textPlace">
          <div className="auto">
            {shouldRenderTitle && <RichText className="title" field={banner.heading} />}
            {shouldRenderText && <RichText className="description" field={banner.text} />}
          </div>
        </div>
        {shouldRenderImage && (
          <div className="picture">
            <figure>
              <Image field={banner.image} />
            </figure>
          </div>
        )}
      </div>
      {shouldRenderAllButtons && (
        <div className="buttons">
          {shouldRenderPrimaryButton && (
            <Button link={primaryButton} variant="contained" color="primary" />
          )}
          {shouldRenderSecondaryButton && (
            <Button link={secondaryButton} variant="contained" color="primary" />
          )}
          {shouldRenderTertiaryButton && (
            <Button link={tertiaryButton} variant="contained" color="primary" />
          )}
        </div>
      )}
    </div>
  );
};
export default withTranslation()(HeaderBannerLandingMobile);
